import { motion } from 'framer-motion';
import React, { HTMLAttributes, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {}

const AnimateWhenVisible = ({ children, className }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{
        opacity: 1,
        transition: { duration: 0.7 },
        y: 0,
      }}
      viewport={{ once: true }}
      className={className}
      layout
    >
      {children}
    </motion.div>
  );
};

export default AnimateWhenVisible;
